<script>
// import axios from "axios";


export default{
    name: "table-evaluasi-tenaga-pelatihan",
    props: {
        // mkp_kode_pembelajaran :{
        //     type: String,
        //     required:true
        // },
        // mkp_judul:{
        //     type: String,
        //     required: true
        // },
    },
    components: [],
    data() {
        return{
            detailAspek: false,
            detailTenagaAhli: false,
        }

    },
    mounted(){

    },
    methods: {
        showDetailTenagaAhli(id) {
            console.log(id);
            this.detailTenagaAhli = true;

            const element = document.getElementById('cardDetailTenagaAhli');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
        showDetailAspek(id) {
            console.log(id);
            this.detailAspek = true;
            const element = document.getElementById('tableDetailAspek');
           if (element) {
               element.scrollIntoView({ behavior: 'smooth', block: 'start' });
           }
        },
        showTenagaAhli() {
            this.detailTenagaAhli = false;
            this.detailAspek = false;
        },
    }
}
</script>
<template>
    <table class="table mb-0 mt-0 table-bordered table-condensed">
    <thead class="blueTheme align-middle">
        <tr>
            <th class="text-center align-middle">No</th>
            <th class="text-center align-middle" style="min-width:20%;">Nama Tenaga<br>Pelatihan</th>
            <th class="text-center align-middle">Unsur Yang<br>Dinilai</th>
            <th class="text-center align-middle" style="max-width:10%;">Rata-rata<br>Penilaian<br>Peserta</th>
            <th class="text-center align-middle" style="max-width:7%;">Kualifikasi</th>
            <th class="text-center align-middle">Aksi</th>
        </tr>
    </thead>
    <tbody>
        <tr class="align-middle">
            <td class="text-center">1</td>
            <td>Nur</td>
            <td class="text-center">Penceramah 1</td>
            <td class="text-center">90</td>
            <td class="text-center">
                <div class="badge badge-pill bg-badge-green font-size-11">
                    Baik
                </div>
            </td>
            <td class="text-center">
                <b-button variant="success" size="sm" role="button" @click="showDetailTenagaAhli(1)">
                    <i class="fas fa-info"></i>
                    &nbsp;
                    <b>Detail</b>
                </b-button>
            </td>
        </tr>
        <tr class="align-middle">
            <td class="text-center">2</td>
            <td>Rizal</td>
            <td class="text-center">Penceramah 2</td>
            <td class="text-center">99</td>
            <td class="text-center">
                <div class="badge badge-pill bg-badge-blue font-size-11">
                    Sangat Baik
                </div>
            </td>
            <td class="text-center">
                <b-button variant="success" size="sm" role="button" @click="showDetailTenagaAhli(2)">
                    <i class="fas fa-info"></i>
                    &nbsp;
                    <b>Detail</b>
                </b-button>
            </td>
        </tr>
        <tr class="align-middle">
            <td class="text-center">3</td>
            <td>Risky</td>
            <td class="text-center">Pengampu Materi 1</td>
            <td class="text-center">60</td>
            <td class="text-center">
                <div class="badge badge-pill bg-badge-yellow font-size-11">
                    Kurang Baik
                </div>
            </td>
            <td class="text-center">
                <b-button variant="success" size="sm" role="button" @click="showDetailTenagaAhli(3)">
                    <i class="fas fa-info"></i>
                    &nbsp;
                    <b>Detail</b>
                </b-button>
            </td>
        </tr>
        <tr class="align-middle">
            <td class="text-center">4</td>
            <td>Andi</td>
            <td class="text-center">Pengampu Materi 2</td>
            <td class="text-center">40</td>
            <td class="text-center">
                <div class="badge badge-pill bg-badge-red font-size-11">
                    Sangat Kurang Baik
                </div>
            </td>
            <td class="text-center">
                <b-button class="btn btn-sm btn-success" role="button" @click="showDetailTenagaAhli(3)">
                    <i class="fas fa-info"></i>
                    &nbsp;
                    <b>Detail</b>
                </b-button>
            </td>
        </tr>
        <tr class="align-middle">
            <td class="text-center">5</td>
            <td>Rezka</td>
            <td class="text-center">Coach 1</td>
            <td class="text-center">-</td>
            <td class="text-center">-</td>
            <td class="text-center">
                <b-button variant="success" size="sm" role="button" @click="showDetailTenagaAhli(3)">
                    <i class="fas fa-info"></i>
                    &nbsp;
                    <b>Detail</b>
                </b-button>
            </td>
        </tr>
        <tr class="align-middle">
            <td class="text-center">6</td>
            <td>Dian</td>
            <td class="text-center">Mentor 1</td>
            <td class="text-center">-</td>
            <td class="text-center">-</td>
            <td class="text-center">
                <b-button variant="success" size="sm" role="button" @click="showDetailTenagaAhli(3)">
                    <i class="fas fa-info"></i>
                    &nbsp;
                    <b>Detail</b>
                </b-button>
            </td>
        </tr>
        <tr class="align-middle">
            <td class="text-center">7</td>
            <td>Mutia</td>
            <td class="text-center">Penguji 1</td>
            <td class="text-center">-</td>
            <td class="text-center">-</td>
            <td class="text-center">
                <b-button variant="success" size="sm" role="button" @click="showDetailTenagaAhli(3)">
                    <i class="fas fa-info"></i>
                    &nbsp;
                    <b>Detail</b>
                </b-button>
            </td>
        </tr>
    </tbody>
</table> 
<div class="col-12 mt-5" id="cardDetailTenagaAhli">
    <b-card header-class="bg-transparent" style="background: #eaeaea;" v-if="detailTenagaAhli == true">
        <div class="row">
            <div class="col-12">
                <div class="card-title mt-2 mb-3">Detail Tenaga Ahli - - -</div>
                <div class="row">
                    <div class="col-md-12">
                        <hr style="margin-top: 7px; margin-bottom: 7px;">
                        <h6 class="mb-3"><b>Nama Tenaga Pelatihan :</b> Rizal</h6>
                        <h6 class="mb-4"><b>Unsur Yang Dinilai :</b> Penceramah 2</h6>
                    </div>
                </div>

                <table class="table mb-0 mt-0 table-bordered table-condensed">
                    <thead class="blueTheme align-middle">
                        <tr>
                            <th class="text-center align-middle">No</th>
                            <th class="text-center align-middle">Aspek</th>
                            <th class="text-center align-middle">Rata-Rata Nilai</th>
                            <th class="text-center align-middle">Aksi</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-center">1</td>
                            <td>Penguasaan materi</td>
                            <td class="text-center">79</td>
                            <td class="text-center">
                                <b-button variant="success" size="sm" role="button" @click="showDetailAspek(1)">
                                    <i class="fas fa-info"></i>
                                    &nbsp;
                                    <b>Detail</b>
                                </b-button>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-center">2</td>
                            <td>Cara menyajikan</td>
                            <td class="text-center">80</td>
                            <td class="text-center">
                                <b-button variant="success" size="sm" role="button" @click="showDetailAspek(1)">
                                    <i class="fas fa-info"></i>
                                    &nbsp;
                                    <b>Detail</b>
                                </b-button>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-center">3</td>
                            <td>Cara menjawab pertanyaan dari peserta</td>
                            <td class="text-center">88</td>
                            <td class="text-center">
                                <b-button variant="success" size="sm" role="button" @click="showDetailAspek(1)">
                                    <i class="fas fa-info"></i>
                                    &nbsp;
                                    <b>Detail</b>
                                </b-button>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-center">4</td>
                            <td>Pemberian motivasi dan inspirasi ke peserta</td>
                            <td class="text-center">90</td>
                            <td class="text-center">
                                <b-button variant="success" size="sm" role="button" @click="showDetailAspek(1)">
                                    <i class="fas fa-info"></i>
                                    &nbsp;
                                    <b>Detail</b>
                                </b-button>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-center"></td>
                            <td><b>Total Rata-rata</b></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row mt-5" id="tableDetailAspek">
            <div class="col-12">
                <div class="table-responsive" v-if="detailAspek == true">
                    <div class="card-title mt-2 mb-3">Detail Aspek Penilaian - - -</div>

                    <table class="table mb-0 mt-0 table-bordered table-condensed">
                        <thead class="greenTheme align-middle">
                            <tr>
                                <th class="text-center">No</th>
                                <th class="text-center">Nama Peserta</th>
                                <th class="text-center">Penguasaan Materi</th>
                                <th class="text-center">Cara Menyajikan</th>
                                <th class="text-center">Cara Menjawab<br>Pertanyaan dari peserta</th>
                                <th class="text-center">Pemberian Motivasi<br>dan<br>Inspirasi ke Peserta</th>
                                <th class="text-center">Rata-rata</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-center">1</td>
                                <td>Yura</td>
                                <td class="text-center">79</td>
                                <td class="text-center">79</td>
                                <td class="text-center">79</td>
                                <td class="text-center">79</td>
                                <td class="text-center">79</td>
                            </tr>
                            <tr>
                                <td class="text-center">2</td>
                                <td>Rahmah</td>
                                <td class="text-center">79</td>
                                <td class="text-center">79</td>
                                <td class="text-center">79</td>
                                <td class="text-center">79</td>
                                <td class="text-center">79</td>
                            </tr>
                            <tr>
                                <td class="text-center">3</td>
                                <td>Mahmud</td>
                                <td class="text-center">79</td>
                                <td class="text-center">79</td>
                                <td class="text-center">79</td>
                                <td class="text-center">79</td>
                                <td class="text-center">79</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </b-card>
</div>                                        
</template>
